var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes",
    clipPath: "url(#clip0_88_358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4031 7.03627C17.6993 6.44571 16.6462 6.53811 16.0567 7.24059L14.4723 9.11547V3.6788C14.4723 3.22313 14.2828 2.78186 13.9525 2.4681L11.8381 0.459558C11.5264 0.163462 11.118 0.000366211 10.6881 0.000366211H1.66988C0.749127 0.000366211 0 0.749493 0 1.67025V17.3301C0 18.2508 0.749127 19 1.66988 19H12.8025C13.7232 19 14.4724 18.2508 14.4724 17.3301V14.2886C14.5408 14.2075 18.5961 9.40396 18.6089 9.38885C19.2021 8.68184 19.1102 7.62957 18.4031 7.03627ZM11.1326 1.3248C13.3596 3.44033 13.2015 3.2857 13.2432 3.34017H11.1326V1.3248ZM13.3591 17.3301C13.3591 17.637 13.1094 17.8867 12.8024 17.8867H1.66988C1.36295 17.8867 1.11324 17.637 1.11324 17.3301V1.67025C1.11324 1.36332 1.36295 1.11361 1.66988 1.11361H10.0193V3.89674C10.0193 4.20415 10.2685 4.45338 10.5759 4.45338H13.3591V10.4328C13.12 10.7157 11.2001 12.9875 10.9926 13.233C10.8268 13.4306 10.7075 13.6676 10.6476 13.9185L10.1303 16.084C10.0814 16.2891 10.1525 16.5042 10.314 16.6398C10.4756 16.7754 10.6999 16.8078 10.8931 16.7241L12.936 15.8386C13.0894 15.7721 13.2324 15.6817 13.3591 15.5732V17.3301ZM12.0351 13.7242L12.8878 14.4397L12.6982 14.6643C12.643 14.7301 12.5721 14.783 12.4932 14.8172L11.4718 15.2599L11.7305 14.1771C11.7505 14.0935 11.7902 14.0145 11.8442 13.9502L12.0351 13.7242ZM13.6059 13.589L12.7536 12.8739C12.8401 12.7716 15.637 9.46196 15.8304 9.2331L16.6809 9.94675L13.6059 13.589ZM17.7572 8.67197L17.3991 9.09613L16.549 8.38282L16.9083 7.95765C17.1046 7.72375 17.4542 7.69325 17.6875 7.88904C17.9254 8.08865 17.9517 8.44019 17.7572 8.67197Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.3495 3.33997H2.7832C2.47579 3.33997 2.22656 3.58919 2.22656 3.89661C2.22656 4.20402 2.47579 4.45325 2.7832 4.45325H8.3495C8.65691 4.45325 8.90614 4.20402 8.90614 3.89661C8.90614 3.58919 8.65691 3.33997 8.3495 3.33997Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.6893 6.7168H2.7832C2.47579 6.7168 2.22656 6.96602 2.22656 7.27344C2.22656 7.58085 2.47579 7.83008 2.7832 7.83008H11.6893C11.9967 7.83008 12.2459 7.58085 12.2459 7.27344C12.2459 6.96602 11.9967 6.7168 11.6893 6.7168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6893 10.0566H2.7832C2.47579 10.0566 2.22656 10.3059 2.22656 10.6133C2.22656 10.9207 2.47579 11.1699 2.7832 11.1699H11.6893C11.9967 11.1699 12.2459 10.9207 12.2459 10.6133C12.2459 10.3058 11.9967 10.0566 11.6893 10.0566Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.3495 13.3964H2.7832C2.47579 13.3964 2.22656 13.6456 2.22656 13.953C2.22656 14.2604 2.47579 14.5096 2.7832 14.5096H8.3495C8.65691 14.5096 8.90614 14.2604 8.90614 13.953C8.90614 13.6456 8.65691 13.3964 8.3495 13.3964Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacture);
export default __webpack_public_path__ + "static/media/facture.48a2d8d7.svg";
export { ForwardRef as ReactComponent };